import ReactMarkdown, { Components } from 'react-markdown';
import React from 'react';

interface MarkdownRendererProps {
  content: string;
  variant?: 'mobile' | 'desktop';
  className?: string;
}

const KeyTakeaways: React.FC<MarkdownRendererProps> = ({
  content,
  variant = 'desktop',
  className = '',
}) => {
  const baseClasses = variant === 'mobile' ? 'prose-xs text-xs max-w-none' : 'text-sm max-w-none';

  const tailwindClasses =
    variant === 'mobile'
      ? '[&>ul]:list-disc [&>ul]:space-y-1 [&>ul]:p-0 [&>ul]:ml-4 [&>li]:p-0 [&>li]:m-0'
      : '[&>ul]:list-disc [&>ul]:space-y-1 [&>ul]:pl-5';

  const textColors = {
    mobile: {
      base: 'text-gray-400',
      strong: 'text-white font-semibold',
      em: 'text-gray-300 italic',
    },
    desktop: {
      base: 'text-white/90',
      strong: 'text-white font-semibold',
      em: 'text-white/80 italic',
    },
  };

  const colors = textColors[variant];

  const components: Components = {
    ul: ({ children, ...props }) => (
      <ul
        {...props}
        className={`list-disc space-y-1 ${variant === 'mobile' ? 'ml-4' : 'pl-5'} ${colors.base}`}
      >
        {children}
      </ul>
    ),
    li: ({ children, ...props }) => (
      <li {...props} className={colors.base}>
        {children}
      </li>
    ),
    p: ({ children, ...props }) => (
      <p {...props} className={`${colors.base} ${variant === 'mobile' ? 'mb-1' : 'mb-2'}`}>
        {children}
      </p>
    ),
    strong: ({ children, ...props }) => (
      <strong {...props} className={colors.strong}>
        {children}
      </strong>
    ),
    em: ({ children, ...props }) => (
      <em {...props} className={colors.em}>
        {children}
      </em>
    ),
  };

  return (
    <ReactMarkdown
      className={`${baseClasses} ${tailwindClasses} ${className}`}
      components={components}
    >
      {content}
    </ReactMarkdown>
  );
};

export default KeyTakeaways;
